export default {
  en: {
    title: 'Buy now. Pay with Klarna at your own pace.',
    subTitle: 'Get what you love, choose how you pay.',
    timelineHeader: 'How it works',
    timelineItems: [
      {
        title: 'At checkout select Klarna',
        description: ''
      },
      {
        title: 'Choose your payment plan',
        description: 'Different payment plans may be shown depending on the purchase amount and credit score.'
      },
      {
        title: 'Complete your checkout',
        description: 'The amount will be charged based on the payment plan you chose.'
      }
    ]
  }
}
